import { createSlice } from '@reduxjs/toolkit';

import { handleGetRiskLevelDescriptions } from './actions';
import { IRiskLevelDescriptionsState } from './slice.interface';

const initialState: IRiskLevelDescriptionsState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const riskLevelDescriptionsSlice = createSlice({
  name: 'risk-level-descriptions',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(handleGetRiskLevelDescriptions.pending, (state: IRiskLevelDescriptionsState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetRiskLevelDescriptions.rejected, (state: IRiskLevelDescriptionsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(
        handleGetRiskLevelDescriptions.fulfilled,
        (state: IRiskLevelDescriptionsState, action) => {
          state.data = action.payload.data;
          state.isLoading = false;
          state.isReady = true;
        },
      );
  },
});

export default riskLevelDescriptionsSlice.reducer;
